import { ExceptionQueue } from "@/features/oversight/reconciliation";

export default function ReconciliationExceptionsPage() {
  return <ExceptionQueue />;
}
